module.exports = __webpack_public_path__ + "img/LogPrincipal.a8270d5e.jpg";